import CircularProgress from '@mui/material/CircularProgress'
import imgConfirm from 'assets/image/auth-steps/unAuth.png'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { appConnector } from 'shared/connector'
import { notifyError } from 'shared/errors/notificate.ts'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'
import { ControlledDialog } from 'shared/ui/Dialog'

import css from './NoWorkingHours.module.scss'

export interface Props {
	open: boolean
	setOpen: (open: boolean) => void
}
export function AccountInUseModal({ open, setOpen }: Props) {
	const { push } = useHistory()

	const [actionDone, setActionDone] = useState(false)
	const [loader, setLoader] = useState(false)

	useEffect(() => {
		setActionDone(true)
	}, [])

	const handlerModal = () => {
		if (!loader) {
			setOpen(!open)
		}
	}

	const onClick = async () => {
		setLoader(true)
		try {
			await appConnector.auth.refreshAccessToken()
		} catch (error) {
			handlerModal()
			notifyError(error)
		} finally {
			setLoader(false)
		}
	}

	return (
		<ControlledDialog
			className={`${css.modalInner} modal-create-campaign`}
			onRequestClose={() => {
				handlerModal()
				if (actionDone) {
					push('/contacts')
					document.location.reload()
				}
			}}
			open={open}
			rootClassName={`${css.dialog} app-scroll`}
		>
			<h2 className='confirm-title'>Account is ready for use!</h2>
			<img alt='imgConfirm' height={212} src={imgConfirm} />
			<p className='modal-description'>Create your first campaign.</p>

			<Button
				className={css.finish}
				onClick={onClick}
				type='button'
				typography={typo.largeButton}
			>
				{loader ? (
					<CircularProgress
						classes={{ colorPrimary: 'material-loader-black' }}
						size={20}
					/>
				) : (
					'Let’s start!'
				)}
			</Button>
		</ControlledDialog>
	)
}
